import {
  isEmpty,
  get,
  map,
  keyBy,
} from 'lodash';
import { list } from 'utils/Api';
import { xSelectSingle } from 'utils/xSelect';
import {
  REQUEST_LOANS,
  REQUEST_LOANS_FAILURE,
  REQUEST_LOANS_SUCCESS,
} from '../constants/ActionTypes';

function requestLoans() {
  return {
    type: REQUEST_LOANS,
  };
}

function requestLoansSuccess(loansData) {
  return {
    type: REQUEST_LOANS_SUCCESS,
    loansData,
    receivedAt: Date.now(),
  };
}

function requestLoansFailure(error) {
  return {
    type: REQUEST_LOANS_FAILURE,
    error,
  };
}

export const fetchLoans = () => async (dispatch, getState) => {
  dispatch(requestLoans());

  const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

  const config = {
    entity: 'EmployeeMasterObjectOnLoan',
    headers: { Authorization: `Bearer ${token}` },
    data: xSelectSingle([{ field: 'EmployeeMasterID', value: EmployeeMasterID, relation: 'eq' }]),
  };

  const configObjectTypes = {
    entity: 'HrObjectType',
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const { data: objectsOnLoan } = await list(config);
    const { data: objectTypes } = await list(configObjectTypes);
    const objectTypesByKey = keyBy(objectTypes, 'HrObjectTypeID');
    const data = map(objectsOnLoan, object => ({ ...object, ObjectTypeName: get(objectTypesByKey, [object.ObjectType, 'HrObjectTypeName'], '') }));
    dispatch(requestLoansSuccess(map(data, e => ({ ...e, Entity: e }))));
  } catch (error) {
    dispatch(requestLoansFailure(error));
  }
};

export function fetchLoansIfNeeded() {
  return (dispatch, getState) => {
    isEmpty(getState().loansReducer.loansData) &&
    dispatch(fetchLoans());
  };
}



// WEBPACK FOOTER //
// ./src/actions/loans.js